interface dataInterface {
    firstName : string;
    lastName: string;
    email:string;
    password:string
}

const Validation = async(data:dataInterface):Promise<{ error: boolean; type: {}; } | { success: boolean; }>=> {
    if(data.firstName ==="" || data.lastName === "" || data.email === "" || data.password === ""){
        let error = {};
        //extra data checking for future if ever use
        if(data.firstName === ""){
            error = {...error,firstName:true};
        }
        if(data.lastName === ""){
            error = {...error,lastName:true};
        }
        if(data.email ===""){
            error = {...error,email:true};
        }
        if(data.password === ""){
            error = {...error,password:true};
        }
        return {error:true,type:error}
    }
    if(data.email){
        //check if it is email or not here 
    }
    const uri:RequestInfo | URL = "http://localhost/";
    //fetch data here
    let response = fetch(
        uri,
        {
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:JSON.stringify(data)
        })
    console.log(response);
    return {success:true};
}

export { Validation }